module.exports = __webpack_public_path__ + "static/media/FounderOfColorUpdated.c6e22073.svg";